module.exports = __webpack_public_path__ + "static/media/favicon.2b70b830.ico";